module.exports = __webpack_public_path__ + "media/common/images/cta/ben-073b8888c7ad9bdbfbd1d91a4e6faacd.jpeg";